import { type IEvent, filterBranchEvents } from '@audacy-clients/core/utils/branch';
import branch from 'branch-sdk';

export const sendEventsToBranch = (events: IEvent[]): void => {
  const matchingEvents = filterBranchEvents(events);

  matchingEvents.forEach((event) => {
    branch.logEvent(event.type);
  });
};
